import API_URL from "../config";

// Builds a URL to a file served from the backend's /uploads directory.
// Accepts either a bare filename ("abc.png") or an already-absolute URL.
export function uploadUrl(filename) {
  if (!filename) return null;
  if (/^https?:\/\//i.test(filename)) return filename;
  return `${API_URL}/uploads/${filename}`;
}

// Resume/cover-letter files are written under uploads/jobApplications/ specifically.
export function applicationFileUrl(filename) {
  if (!filename) return null;
  if (/^https?:\/\//i.test(filename)) return filename;
  return `${API_URL}/uploads/jobApplications/${filename}`;
}

export default uploadUrl;
